import { cn } from "@app/lib/utils";
import { linksDrawerAtom, searchDrawerAtom } from "@design-system/atoms";
import { useMedia } from "@design-system/hooks/use-media";
import { ColoredXIcon } from "@design-system/icons";
import { useState } from "react";

export function LinksDrawerButton() {
  const [isHovered, setIsHovered] = useState(false);

  const [searchDrawerAtomOpened, linksDrawerAtomOpened] = [
    searchDrawerAtom.useOpened(),
    linksDrawerAtom.useOpened(),
  ];

  const { isSmallerScreen } = useMedia(1024);

  return (
    <>
      <button
        onClick={() => {
          linksDrawerAtom.toggle();
          searchDrawerAtom.close();
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={cn(
          "flex h-[3.5rem] w-[3.5rem] flex-col items-center justify-center gap-2 rounded-[4.7rem] border border-transparent bg-white/5 p-3 transition-all duration-300 hover:border focus:!ring-offset-0",
          (searchDrawerAtomOpened && !isSmallerScreen) || linksDrawerAtomOpened
            ? "bg-rich-blue !bg-opacity-5"
            : "",
          !isSmallerScreen && "hover:border-bright-orange hover:bg-white",
        )}
      >
        {searchDrawerAtomOpened || !linksDrawerAtomOpened ? (
          Array.from({ length: 2 }, (_, index) => (
            <span
              key={index}
              className={cn(
                "h-[3px] w-[85%] rounded-[6.325rem] bg-white transition-all duration-500",
                index === 0 ? "ms-auto" : "me-auto",
                isHovered && !isSmallerScreen && "w-full bg-bright-orange",
                searchDrawerAtomOpened && !isSmallerScreen && "bg-rich-blue",
              )}
            />
          ))
        ) : (
          <ColoredXIcon className="w-6 h-6" />
        )}
      </button>
    </>
  );
}
